var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotating-plane-spinner",attrs:{"hidden":!_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }